import {Component, ViewChild} from '@angular/core';
import {GenericDataViewService} from '../generic-data-view.service';
import {IonicPage, Navbar, NavParams} from 'ionic-angular';
import {
  DetailsConfig
} from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/details/interfaces/details-config.interface';
import {MapOfStringTo} from '../../modules/ranking/interfaces/utils';
import {
  FormDefinition
} from '../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-definition.interface';
import {HttpClient} from '@angular/common/http';
import {ProcessWrapperService} from '../../modules/core/services/process-wrapper-service/process-wrapper.service';
import {
  DetailsComponent
} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/details/details.component";
import {
  ProcessFormService
} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process-form.service";
import { element } from 'protractor';
import {
  ProcessAction
} from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/process-action.interface';
import { finalize } from 'rxjs/operators';
import { pipe } from 'rxjs';
import {
  ProcessFormMappingConfig
} from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/process-form-mapping-config.interface';
import { Utils } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/utils/utils.class';
import {
  ProcessEntry, ScreenActions,
} from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/screen-actions.interface';

@IonicPage()
@Component({
  selector: 'generic-data-view-details',
  templateUrl: './generic-data-view-details.page.html',
})
export class GenericDataViewDetailsPage {
  @ViewChild('details') details: DetailsComponent;
  public originalConfig: DetailsConfig;
  public localConfigCopy: DetailsConfig;
  public baseUrl: string;
  public db: any;
  public loading: boolean = false;
  public detailsData: MapOfStringTo<any>; // data to evaluate values in details component
  public isFirstEntry: boolean = true;
  public screenActions: ProcessEntry[];
  public screenActionsFab: ScreenActions;

  constructor(
    private genericDataViewService: GenericDataViewService,
    public navParams: NavParams,
    private processService: ProcessWrapperService,
    private http: HttpClient,
    private processFormService: ProcessFormService,
  ) {
    const data = this.navParams.data;
    this.originalConfig = this.genericDataViewService.getConfig(data.viewId);
    this.localConfigCopy = JSON.parse(JSON.stringify(this.originalConfig));
    this.baseUrl = this.genericDataViewService.getBaseUrl(this.originalConfig);
    this.detailsData = data.element;
  }

  ngOnInit(): void {
    if (!this.isFirstEntry) {
      this.details.reload();
    }
    this.filterProcessActionsBasedOnData();
    this.isFirstEntry = false;
  }

  private filterProcessActionsBasedOnData() {
    if (this.originalConfig.screenActions && this.originalConfig.screenActions.processList) {
      this.screenActions = this.originalConfig.screenActions.processList.filter(
        (p) => Utils.evaluateVisibilityCondition(p.visibilityCondition, this.detailsData),
      );
      this.localConfigCopy.screenActions.processList = this.screenActions;
      this.screenActionsFab = JSON.parse(JSON.stringify(this.localConfigCopy.screenActions));
    }
  }

  onButtonClick($event: { process?: any; element?: Object }): void {
   let processEntry = this.localConfigCopy.screenActions.processList.find((p) => p.processKey === $event.process.processKey);
    let screenData = this.details.getScreenData() ? JSON.parse(JSON.stringify(this.details.getScreenData())) : null;
    this.handleDetailsElementClick({ element: { process: processEntry, element: screenData}, target: null });
  }

  private handleProcessAction(processKey: string, data: Object, sendButtonText: string, mappingConfig?: any): void {
    this.setLoading(true);
    let scopedConfig = this.originalConfig;
    this.processService.getProcessWithForm(processKey).subscribe((formDefinition: FormDefinition) => {
      const fields = formDefinition.form;
      const formName = formDefinition.formName;
      const formJson = this.processFormService.mapFormData(mappingConfig && mappingConfig.formMapping ? mappingConfig : scopedConfig, fields, data);
      this.processFormService.setTechnicalParametersOnField(
        (mappingConfig && mappingConfig.formFieldParametersConfig) ? mappingConfig.formFieldParametersConfig
          : (this.localConfigCopy && this.localConfigCopy.formFieldParametersConfig) ? this.localConfigCopy.formFieldParametersConfig : null
        , formJson, data);
      this.processService.initProcess({formJson, key: processKey, data, formName, sendButtonText})
        .delay(2000)
        .subscribe(
          () => {
            this.details.reload();
          },
          (error) => {},
          () => {
            this.setLoading(false)
          }
        )
    });
  }

  setLoading(value): void {
    this.loading = value;
  }

  onDetailsDataUpdated(newData: MapOfStringTo<any>): void {
    this.detailsData = newData;
    this.filterProcessActionsBasedOnData();
  }

  handleDetailsElementClick($event: { element: Object; target: EventTarget }) {
    if($event.element['process'] ) {
      let processAction = $event.element as ProcessAction & {formMapping: ProcessFormMappingConfig};
      let screenData = this.details.getScreenData() ? JSON.parse(JSON.stringify(this.details.getScreenData())) : null;
      this.processFormService.appendFieldsFromMappingParentObjectIntoElement(
        processAction,
        processAction.process.formMappingFromParentObject ? processAction.process.formMappingFromParentObject : this.originalConfig.formMappingFromParentObject,
        screenData,
      );
      this.handleProcessAction(processAction.process.processKey, processAction.element, processAction.process.sendButtonText, processAction.process);
    }
  }

  inFabMode() {
    return this.originalConfig.screenActions && (!this.originalConfig.screenActions.displayMode || this.originalConfig.screenActions.displayMode === 'FAB');
  }

  onButtonRowProcessClick(i: number) {
    let processEntry = this.localConfigCopy.screenActions.processList[i];
    this.handleDetailsElementClick({ element: { process: processEntry }, target: null });
  }
}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view-details/generic-data-view-details.page.ts